import { useTranslation } from "react-i18next";
import { Info } from "lucide-react";
import usePrefersReducedMotion from "../hooks/usePrefersReducedMotion";

/**
 * Fixed top strip, always present (unlike OfflineBanner/CookieConsentBanner,
 * which are conditional) — Navbar and OfflineBanner are offset down by this
 * banner's own height (`top-8` instead of `top-0`) to sit below it rather
 * than overlapping.
 */
export default function DisclaimerBanner() {
  const { t } = useTranslation();
  const reducedMotion = usePrefersReducedMotion();
  const text = t("disclaimer.text");

  return (
    <div
      role="note"
      className="fixed inset-x-0 top-0 z-[70] flex h-8 items-center overflow-hidden bg-ocean-900 text-foam-50"
    >
      {reducedMotion ? (
        <p className="w-full truncate px-4 text-center text-xs font-medium">
          <Info className="mr-1.5 inline h-3.5 w-3.5 shrink-0 align-[-2px]" />
          {text}
        </p>
      ) : (
        <div className="flex w-max shrink-0 animate-marquee items-center" aria-hidden={false}>
          {[0, 1].map((copy) => (
            <span key={copy} className="flex shrink-0 items-center whitespace-nowrap px-4 text-xs font-medium">
              <Info className="mr-1.5 h-3.5 w-3.5 shrink-0" />
              {text}
              <span className="ml-4 text-foam-50/40">•</span>
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
